import { Box, IconButton } from '@mui/material'
import { styled } from '@mui/system'

export const StyledMonthPicker = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0),
  },
}))

export const StyledMonthAndYearContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isWeekly' && prop !== 'isDaily',
})<{ isWeekly?: boolean; isDaily?: boolean }>(({ isWeekly, isDaily }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: isWeekly ? 'auto' : isDaily ? 85 : 65,
  minWidth: isWeekly ? 150 : ' ',
}))

export const StyledMonthPickerIconButton = styled(IconButton)(({ theme }) => ({
  width: 28,
  height: 28,
  '& svg': {
    color: theme.palette.text.mediumEmphasis,
  },
  '&:hover': {
    svg: {
      color: theme.palette.text.highEmphasis,
    },
  },
}))
